if($('.company-info-content ').length) {
  var userAgent = window.navigator.userAgent.toLowerCase();

  if(!userAgent.indexOf('msie') != -1 || !userAgent.indexOf('trident') != -1) {
  (function () {
    const loadingArea = document.querySelector('#loading');

    function noScroll(event) {
      event.preventDefault();
    }

    function loadingAnime() {
      setTimeout(function () {
        loadingArea.style.opacity = 0;
      }, 20);
    }

    document.addEventListener('touchmove', noScroll, { passive: false });
    document.addEventListener('mousewheel', noScroll, { passive: false });

    window.addEventListener('load', () => {
      loadingAnime();
      document.removeEventListener('touchmove', noScroll, { passive: false });
      document.removeEventListener('mousewheel', noScroll, { passive: false });
    });
  })();
  };
}
